import React, { useState, useEffect } from 'react';
import '@css/index.scss'
import {getImage} from "@public/ulits";
import Footer from "@public/components/Footer";
import Header from "@components/Header";
import { api } from '@public/ulits/api';
import usePageLang from '@public/hooks/usePageLang';
import { Spin } from 'antd';



export default ()=>{
    const [aboutData, setAboutData] = useState(null);
    const [loading, setLoading] = useState(true);
    const { pick } = usePageLang();

    useEffect(() => {
        api.getAbout()
            .then(res => {
                if (res && res.data) setAboutData(res.data);
            })
            .catch(() => {})
            .finally(() => setLoading(false));
    }, []);

    const bannerDesktop = aboutData?.banner_desktop || getImage('banner.jpg');
    const bannerMobile = aboutData?.banner_mobile || getImage('mobile-banner.jpg');

    return (
        <div className={`page-index `}>
            <div className="w-full">
                <Header />
                <div className={`lg:bg-img bg-mobile-img lg:w-[100%] w-full lg:h-[680px] h-[480px] bg-cover bg-center relative`} style={{'--bg': `url(${bannerDesktop})`,'--mobile-bg':`url(${bannerMobile})`}}>
                    <img className="logo lg:w-[560px] w-[240px] h-auto absolute left-0 right-0 mx-auto top-1/2  translate-y-[-35%]" width='30rem' height='auto' src={getImage("logo-w.svg")}/>
                </div>
                <div className={`lg:w-[70%] lg:px-0 px-5 text-white mx-auto lg:py-[66px] py-6 pb-8`}>
                    {loading ? (
                        <div className="flex justify-center py-20">
                            <Spin size="large" />
                        </div>
                    ) : aboutData ? (
                        <>
                            <h1 className={`lg:text-[40px] text-2xl font-bold`}>{pick(aboutData.title_en, aboutData.title_zh)}</h1>
                            {pick(aboutData.content_en, aboutData.content_zh) && (
                                <div className={`rich-text lg:text-xl text-base lg:pt-5 pt-4 mx-auto lg:leading-8 leading-5 lg:tracking-wide text-[rgba(255,255,255,0.8)]`}
                                    dangerouslySetInnerHTML={{ __html: pick(aboutData.content_en, aboutData.content_zh) }} />
                            )}
                        </>
                    ) : null}
                </div>
                <Footer />
            </div>
        </div>
    )
}
